module.exports = __webpack_public_path__ + "img/aliareIcon.0e63d9c6.svg";